export const fmtMoney = (n, currency = "USD") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 2 }).format(n || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-US", {
      month: "short", day: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
};

export const statusColor = (s) => ({
  pending: "bg-amber-500/20 text-amber-400 border-amber-500/30",
  processing: "bg-sky-500/20 text-sky-400 border-sky-500/30",
  delivered: "bg-emerald-500/20 text-emerald-400 border-emerald-500/30",
  canceled: "bg-rose-500/20 text-rose-400 border-rose-500/30",
  approved: "bg-sky-500/20 text-sky-400 border-sky-500/30",
  rejected: "bg-rose-500/20 text-rose-400 border-rose-500/30",
  paid: "bg-emerald-500/20 text-emerald-400 border-emerald-500/30",
}[s] || "bg-slate-500/20 text-slate-400 border-slate-500/30");
